import { FC } from "react";
import styles from './index.module.less';
import Title from '../../common/title';
import EntranceItem from "./EntranceItem";
import shisheng from '../../assets/en04.svg';
import yuanji from '../../assets/en03.svg';
import xiaoji from '../../assets/en02.svg';
import kufang from '../../assets/en01.svg';
import { lab, school, admin, warehouse } from "../../config";

const Index: FC = (props) => {
    const jump = (url) => {
        window.location.href = url;
    }
    const data = [
        {
            text: '实验室师生',
            backgroundColor: '#F4FAFF',
            hoverColor: '#D3EAFE',
            textColor: '#005BAC',
            icon: shisheng,
            url: lab
        },
        {
            text: '院级管理员',
            backgroundColor: '#FCF6F7',
            hoverColor: '#FFE4E8',
            textColor: '#C30D23',
            icon: yuanji,
            url: school
        },
        {
            text: '校级管理员',
            backgroundColor: '#FFFBF4',
            hoverColor: '#FFF0D6',
            textColor: '#E89A11',
            icon: xiaoji,
            url: admin
        },
        {
            text: '库房管理员',
            backgroundColor: '#F0FCF9',
            hoverColor: '#D5F3EA',
            textColor: '#02A060',
            icon: kufang,
            url: warehouse
        },
    ];
    return (
        <div style={{height: props.height, width: props.width}} className={styles.body}>
            <Title title='用户入口'></Title>
            <div className={styles.content}>
                {
                    data.map((item) => {
                        return (
                            <div>
                                <EntranceItem onClick={() => jump(item.url)} {...item}></EntranceItem>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
}

export default Index;